<template>
	<button class="v5-button" type="button" @click="next($event)">
		<slot></slot>
	</button>
</template>
<script>
	import Active from './../../mixins/active';
	export default {
		name: 'v5-button',
		props: {
			text: {
				type: String
			},
			delay: {
				type: Number,
				default: 0
			}
		},
		mixins: [Active],
		methods: {
			next(e) {
				setTimeout(() => {
					this.$emit('on-click', e);
				}, this.delay);
			}
		}
	};

</script>
<style lang="scss">
	@import './style.scss';

</style>



// WEBPACK FOOTER //
// index.vue?a1cc8342